import React from 'react';
import { Navigate } from 'react-router';

import { LimitedPartnerCommitments } from 'packages/limitedPartners/ui/LimitedPartnerCommitments';
import { RouteErrorBoundary } from '~/contexts/MonitoringProvider';

const RouteBase = () => {
  return <LimitedPartnerCommitments />;
};

export const Route = () => {
  return (
    <RouteErrorBoundary
      fallback={({ message, showErrorToast }) => {
        showErrorToast(message);
        return <Navigate to="/" />;
      }}
    >
      <RouteBase />
    </RouteErrorBoundary>
  );
};
